import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatBRL(value: number): string {
  return new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL", maximumFractionDigits: 0 }).format(value);
}

export function formatPct(value: number, decimals = 2): string {
  return `${value.toFixed(decimals).replace(".", ",")}%`;
}

export function formatDelta(value: number, unit: "%" | "pp" = "%"): string {
  const prefix = value > 0 ? "+" : "";
  return `${prefix}${value.toFixed(unit === "pp" ? 1 : 0).replace(".", ",")}${unit}`;
}
